// @flow
import React from 'react';
import Slideshow from 'components/Slideshow';
import ScrollContext from 'containers/ScrollContext';
import type { ImageGalleryBlockData } from 'api/cms';

const { useState, useContext, useRef, useCallback, useEffect } = React;

const ImageGalleryBlock = ({
  data: { images },
  blockIndex
}: {
  data: ImageGalleryBlockData,
  blockIndex: number
}) => {
  const [show, setShow] = useState(blockIndex > 2);
  const [, scrollY] = useContext(ScrollContext);
  const lazyRef = useRef(null);

  const update = useCallback(
    () => {
      if (!show && lazyRef && lazyRef.current) {
        const offsetY = lazyRef.current.getBoundingClientRect().top - 200;
        const inView = offsetY < window.innerHeight + scrollY;
        if (inView && !show) {
          setShow(true);
        }
      }
    },
    [scrollY, show]
  );

  useEffect(
    () => {
      update();
    },
    [scrollY, update]
  );

  return show ? (
    <Slideshow items={images} data-qa-id="cms-image-gallery" round />
  ) : (
    <div ref={lazyRef} />
  );
};

export default ImageGalleryBlock;
